/* eslint-disable @next/next/no-img-element */
import { Button } from "app-v2";
import { Badge } from "app-v2";
import { UserNav, NavigationMenuCards } from "app-v2";
import Logo from "../../icons/Logo";
import { HeaderSearchBar } from "./HeaderSearchBar";
import { HamburgerMenu } from "./HamburgerMenu";
import { useSelector } from "react-redux";
import { AuthModalWrapper } from "../../components/web/Auth/AuthModal";
import { useState } from "react";
import { LicLogo } from "../../icons/LicLogo";

interface HeaderProps {
  showSearch?: boolean;
  cities?: any;
  type?: any;
}

const bankName = process.env.NEXT_PUBLIC_BANK;

export const BankLogoOnHeaderRightPosition = () => {
  return (
    <a href="/" tabIndex={-1}>
      <span className="sr-only">Auction Bazaar</span>
      {bankName?.startsWith("axis") ? (
        <>
          <div className="hidden lg:block">
            <img
              src="./Axis_Bank_logo.png"
              width="160"
              height="80"
              alt="Axis Bank Logo"
            />
          </div>
          <div className="lg:hidden">
            <img
              src="./Axis_Bank_logo.png"
              width="100"
              height="80"
              alt="Axis Bank Logo"
            />
          </div>
        </>
      ) : (
        <>
          <div className="hidden lg:block">
            <img
              src="./alliances/lic.png"
              width="160"
              height="80"
              alt="Lic Housing Bank Logo"
            />
          </div>
          <div className="lg:hidden">
            <img
              src="./alliances/lic.png"
              width="100"
              height="80"
              alt="Lic Housing Bank Logo"
            />
          </div>
        </>
      )}
    </a>
  );
};
export default function Header({
  showSearch = false,
  cities,
  type = false,
}: HeaderProps) {
  const isLoggedIn = useSelector((state: any) => state.auth.user);
  const [modalOpen, setModalOpen] = useState(false);
  const handlePostYourPropertyClick = () => {
    if (!type) {
      if (isLoggedIn) window.open(`/post-your-property`, "_blank");
      else setModalOpen(true);
    } else {
      window.open(
        `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/post-your-property`,
        "_blank",
      );
    }
  };
  const handleBiddingClick = () => {
    // if (!type) {
    //   if (isLoggedIn) window.open(`/post-your-property`, "_blank");
    //   else setModalOpen(true);
    // } else {
    //   window.open(
    //     `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/post-your-property`,
    //     "_blank"
    //   );
    // }
    if (window != undefined) {
      if (isLoggedIn) {
        window.location.href = process.env.NEXT_PUBLIC_BIDDER_URL || "";
      } else setModalOpen(true);
    }
  };
  return (
    <>
      {/* Web Design */}
      <div className="hidden lg:flex ">
        <div className="flex h-16 items-center px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <div className="mr-10">
            <Logo />
          </div>

          {showSearch ? (
            <HeaderSearchBar cities={cities} />
          ) : (
            <NavigationMenuCards />
          )}

          {bankName ? (
            <BankLogoOnHeaderRightPosition />
          ) : (
            <div className="ml-auto flex items-center gap-x-4 mid:gap-x-[21px]">
              {/* Post Your Property */}
              <Button
                onClick={
                  process.env.NEXT_PUBLIC_PYP_ENABLE === "true"
                    ? handlePostYourPropertyClick
                    : () => {}
                }
                variant={"outline"}
                className="bg-[#EFEFEF] h-custom-35 w-[190px] py-custom-9 px-[14px] flex justify-between font-openSans font-semibold text-web-body-sm leading-4 border-none"
              >
                Post Your Property
                <Badge
                  variant={"default"}
                  className="bg-[#ACE459] w-custom-44 h-custom-17  font-openSans rounded-sm font-normal text-brand-textBlack p-0 border-none"
                >
                  <p className="font-openSans font-normal text-[10px] leading-[13px] text-brand-textBlack mx-[10px]">
                    FREE
                  </p>
                </Badge>
              </Button>

              {/* Bidding Portal */}
              {type !== "bidder" && (
                <Button
                  onClick={handleBiddingClick}
                  className="bg-brand-bgBlack font-openSans font-semibold text-web-body-sm leading-4 text-white pt-[9px] pb-[10px] px-[30px] h-[35px] w-[105px]"
                >
                  {" "}
                  Bidding
                </Button>
              )}

              {/* User Profile */}
              <div
                style={{
                  pointerEvents: type ? "none" : "auto",
                  opacity: type ? 0.5 : 1,
                }}
              >
                <UserNav userLoggedin={isLoggedIn} />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Design */}
      <div className=" flex flex-col lg:hidden ">
        <div className="flex h-14 items-center w-full px-customPaddingMobile py-[10px]">
          <div className={`${type === "bidder" ? "hidden" : ""}`}>
            <HamburgerMenu
              className="mr-4"
              userLoggedin={isLoggedIn}
              type={type}
            />
          </div>

          <Logo height="28px" width="98px" />

          {bankName ? (
            <div className="flex flex-1 items-end justify-end w-64">
              <BankLogoOnHeaderRightPosition />
            </div>
          ) : (
            <div className="ml-auto flex items-center">
              {type !== "bidder" && (
                <Button
                  // onClick={() => {
                  //   if (window != undefined) {
                  //     window.location.href =
                  //       process.env.NEXT_PUBLIC_BIDDER_URL || "";
                  //   }
                  // }}
                  onClick={handleBiddingClick}
                  className="bg-brand-bgBlack font-openSans font-semibold text-web-body-sm leading-4 text-white px-[30px] h-[33px] w-[105px]"
                >
                  Bidding
                </Button>
              )}
            </div>
          )}
        </div>
        {showSearch && (
          <div className="h-[60px] w-full px-4 bg-brand-bgLightGrey flex items-center justify-center">
            <HeaderSearchBar cities={cities} />
          </div>
        )}
      </div>

      <AuthModalWrapper
        userLoggedin={isLoggedIn}
        authModelOpen={modalOpen}
        setAuthModelOpen={setModalOpen}
      />
    </>
  );
}
